import { Routes } from '@angular/router';
import { authGuard } from './guards/auth/auth';
import { Landing } from './pages/landing/landing';

export const routes: Routes = [
  {
    path: '',
    component: Landing,
  },
  {
    path: 'getting-started',
    loadComponent: () =>
      import('./pages/getting-started/getting-started').then((m) => m.GettingStarted),
  },
  {
    path: 'plans',
    loadComponent: () => import('./pages/plans/plans').then((m) => m.Plans),
  },
  {
    path: 'runs',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/recent-runs/recent-runs').then((m) => m.RecentRuns),
  },
  {
    path: 'runs/:runId',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/run-details/run-details').then((m) => m.RunDetails),
  },
  {
    path: 'run-groups',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/run-groups/run-groups').then((m) => m.RunGroups),
  },
  {
    path: 'api-keys',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/api-keys/api-keys').then((m) => m.ApiKeys),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
